module.exports = __webpack_public_path__ + "static/img/图层 539.73422527.png";